var banner = {
    bindings : {
        source : "@bannerSrc",
        dd : "@"
    },
    controller : function BannerCtrl ($element, $sce) {

        function init () {
            
            ctrl.trustedsrc = $sce.trustAsResourceUrl(ctrl.source);
        }

        function link () {
            console.log("WHAT", ctrl.trustedsrc, ctrl.dd);
            ctrl.ready = true;
            // $element[0].style.height = ctrl.height+"px";
            // $element[0].style.width = ctrl.width+"px";

            // var script = document.createElement('script');
            // script.type = 'text/javascript';
            // script.src = ctrl.trustedsrc;
            // $element[0].appendChild(script);
        }

        var ctrl = this;
        this.$onInit = init;
        this.$postLink = link;
    },
    template : '<div class="banner" ng-if="$ctrl.ready"><script type="text/javascript" ng-src="{{$ctrl.trustedsrc}}"></script></div>'
};